import { Observable, throwError } from 'rxjs';

import { ErrorHandlerService } from '../shared/error-handler.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StaticPageInterface } from '@app/interfaces/_index';
import { WordpressPaging } from '@app/enums/_index';
import { catchError } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { getCacheBustedParams } from '@app/utilities/cacheBustedHttpParams.utilities';

@Injectable({
  providedIn: 'root',
})
export class QuickStartGuideService extends ErrorHandlerService {
  private quickStartGuideURL = `${environment.cms.url}/wp-json/wp/v2/quick_start_guide`;

  constructor(private http: HttpClient) {
    super();
  }

  /**
   * Returns the quick start guide from the wordpress API
   * @returns Quick Start Guide observable response
   */
  getQuickStartGuide(): Observable<StaticPageInterface[]> {
    const quickStartGuideURLParams = getCacheBustedParams()
      .append(WordpressPaging.ORDER_BY_KEY, WordpressPaging.ORDER_BY_VALUE)
      .append(WordpressPaging.ORDER_KEY, WordpressPaging.ORDER_VALUE);

    return this.http.get(`${this.quickStartGuideURL}`, { params: quickStartGuideURLParams }).pipe(
      catchError((err) => {
        console.log(`Service error has occurred`, err);
        return throwError(() => new Error(err));
      }),
      catchError(this.handleError<StaticPageInterface[]>('getTermsAndConditions', []))
    );
  }
}
